// eslint-disable-next-line
import util from 'util';

import * as actionTypes from '../actionTypes';

const initialState = {
  loginState: "startup",
  user: {},
  sessionKey: "",
  snackMessageQueue: [],
  snackMessageItem: null,
  availableScreens: [
    {
      path: '/',
      name: 'dashboard',
      label: 'Dashboard',
      default: true,
    },
    {
      path: '/callhandling',
      name: 'callhandling',
      label: 'Call Handling',
      default: false,
    },
    {
      path: '/activity',
      name: 'activity',
      label: 'Activity',
      default: false,
    },
    {
      path: '/chat-activity',
      name: 'chat',
      label: 'Chat',
      default: false,
    },
    {
      path: '/text-activity',
      name: 'text',
      label: 'Text',
      default: false,
    },
    {
      path: '/status',
      name: 'status',
      label: 'Status',
      default: false,
    },
    {
      path: '/contacts',
      name: 'contacts',
      label: 'Contacts',
      default: false,
    },
    // {
    //   path: '/blocked',
    //   name: 'Blocked Contacts',
    //   label: 'Blocked Contacts',
    //   default: false,
    // },
    
    // {
    //   path: '/integrations',
    //   name: 'integrations',
    //   label: 'Integrations',
    //   default: false,
    // },
    {
      path: '/vip',
      name: 'VIP Contacts',
      label: 'VIP Contacts',
      default: false,
    },
    {
      path: '/profile',
      name: 'profile',
      label: 'Account',
      default: false,
    },
    // {
    //   path: '/reports',
    //   name: 'reports',
    //   label: 'Reports',
    //   default: false,
    // },
    // {
    //   path: '/profile',
    //   name: 'profile',
    //   label: 'Profile',
    //   default: false,
    // },
    // {
    //   path: '/leads',
    //   name: 'WebLeads',
    //   label: 'Web Leads',
    //   default: false,
    // },
  ],
  showSplash: false,
  checkSaveIdentity: "",
  passwordChangeKey: "",
  passwordChangeKeyExpiration: "",
  manualPasswordChange: false,
  pushEndpoint: "",
  pushKey: "",
  pushAuth: "",
  updatingUser: false,
  updateUserAgain: false,
  busyOpen: false,
  busyMessage: "",
  apiInfo: { production : true },
  agentUserSession: "",
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_USER : {
      return({...state, user: action.payload.user });
    }
    case actionTypes.SET_SESSION_KEY : {
      return({...state, sessionKey: action.payload.sessionKey });
    }
    case actionTypes.SET_SNACK_MESSAGE_QUEUE : {
      return({...state, snackMessageQueue: action.payload.snackMessageQueue });
    }
    case actionTypes.SET_SNACK_MESSAGE_ITEM : {
      return({...state, snackMessageItem: action.payload.snackMessageItem });
    }
    case actionTypes.SET_LOGIN_STATE : {
      return({...state, loginState: action.payload.loginState });
    }
    case actionTypes.SET_AVAILABLE_SCREENS : {
      return({...state, availableScreens: action.payload.availableScreens });
    }
    case actionTypes.SET_SHOW_SPLASH : {
      return({...state, showSplash: action.payload.showSplash });
    }
    case actionTypes.SET_CHECK_SAVE_IDENTITY : {
      return({...state, checkSaveIdentity: action.payload.checkSaveIdentity });
    }
    case actionTypes.SET_PASSWORD_CHANGE_KEY : {
      return({...state, passwordChangeKey: action.payload.passwordChangeKey });
    }
    case actionTypes.SET_PASSWORD_CHANGE_KEY_EXPIRATION : {
      return({...state, passwordChangeKeyExpiration: action.payload.passwordChangeKeyExpiration });
    }
    case actionTypes.SET_MANUAL_PASSWORD_CHANGE : {
      return({...state, manualPasswordChange: action.payload.manualPasswordChange });
    }
    case actionTypes.SET_PUSH_ENDPOINT : {
      return({...state, pushEndpoint: action.payload.pushEndpoint });
    }
    case actionTypes.SET_PUSH_KEY : {
      return({...state, pushKey: action.payload.pushKey });
    }
    case actionTypes.SET_PUSH_AUTH : {
      return({...state, pushAuth: action.payload.pushAuth });
    }
    case actionTypes.SET_UPDATING_USER : {
      return({...state, updatingUser: action.payload.updatingUser });
    }
    case actionTypes.SET_UPDATE_USER_AGAIN : {
      return({...state, updateUserAgain: action.payload.updateUserAgain });
    }
    case actionTypes.SET_BUSY_OPEN : {
      return({...state, busyOpen: action.payload.busyOpen });
    }
    case actionTypes.SET_BUSY_MESSAGE : {
      return({...state, busyMessage: action.payload.busyMessage });
    }
    case actionTypes.SET_API_INFO : {
      return({...state, apiInfo: action.payload.apiInfo });
    }
    case actionTypes.SET_AGENT_USER_SESSION : {
      return({...state, agentUserSession: action.payload.agentUserSession });
    }
    default: {
      return(state);
    }
  }  
}
